<template>
  <div>
    <div class="card top-draft">
      <div class="card-body">
        <div class="col-lg-12 mg-top-1">
          <b-button variant="primary" @click="toCreate()">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            添加
          </b-button>
        </div>

        <div class="col-lg-12 list-header mg-top-1 pad-header-bg clearfix">
          <div class="header-item-fix">
            <b-form-input
              size="sm"
              type="text"
              v-model="pageParams.contentKeyword"
              placeholder="请输入搜索内容"
            ></b-form-input>
            <b-button size="sm" variant="primary" @click="search()">
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
          <div class="header-item-fix">
            <b-form-select
              @change="search()"
              v-model="pageParams.showState"
              class="form-select"
              :options="statusList"
              type="text"
            ></b-form-select>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="table-responsive">
            <table
              class="table project-list-table table-nowrap table-centered table-borderless align-middle table-hover"
            >
              <thead>
                <tr>
                  <th scope="col" style="width: 70px;">ID</th>
                  <th scope="col" class="w-300">名称</th>
                  <th scope="col">优惠方案</th>
                  <th scope="col">类型</th>
                  <th scope="col">总库存</th>
                  <th scope="col">可用库存</th>
                  <th scope="col">发放量</th>
                  <th scope="col">核销数量</th>
                  <th scope="col">状态</th>
                  <th scope="col">创建日期</th>
                  <th scope="col"><span class="px-2">操作</span></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td class="w-300 white-inherit">{{ item.title }}</td>
                  <td>
                    {{
                      item.couponType == 1
                        ? "代金券"
                        : item.couponType == 2
                        ? "折扣券"
                        : item.couponType == 3
                        ? "通用券"
                        : "--"
                    }}
                  </td>
                  <td>
                    {{
                      item.codeType == 1
                        ? "自有券"
                        : item.codeType == 2
                        ? "第三方券"
                        : "未知"
                    }}
                  </td>
                  <td>{{ item.countNumber || "0" }}</td>
                  <td>{{ item.quantity || "0" }}</td>
                  <td>{{ item.grantNumber || "0" }}</td>
                  <td>{{ item.verifyNumber || "0" }}</td>
                  <td>
                    <el-tooltip
                      :content="item.status == 1 ? '点击下架' : '点击上架'"
                    >
                      <span
                        @click="modifyStatus(item, '0')"
                        v-if="item.status == 1"
                        class="dsply-fix status-open"
                        ><i></i>上架</span
                      >
                      <span
                        @click="modifyStatus(item, '1')"
                        v-if="item.status == 0"
                        class="dsply-fix status-off"
                        ><i></i>下架</span
                      >
                    </el-tooltip>
                  </td>
                  <td>{{ item.createdAt || "--" }}</td>
                  <td>
                    <button
                      type="button"
                      class="btn-sm btn btn-primary m-r-10"
                      @click="toDetail(item)"
                    >
                      编辑
                    </button>
                    <button
                      type="button"
                      class="btn-sm btn btn-warning m-r-10"
                      @click="toReceiveList(item)"
                    >
                      领用列表
                    </button>
                    <button
                      v-if="item.codeType == 2"
                      type="button"
                      class="btn-sm btn btn-info m-r-10"
                      @click="toThirdParty(item)"
                    >
                      第三方券码
                    </button>
                    <button
                      type="button"
                      class="btn-sm btn btn-danger"
                      @click="remove(item)"
                    >
                      移除
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <pagination
            ref="page"
            @pageCallback="pageCallback"
            
          ></pagination>
        </div>
        <app-list-loading ref="loading"></app-list-loading>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import pagination from "@/components/pagination/pagination.vue";
import conpon from "../../../../server/api/coupons";

/**
 * Contacts-list component
 */
export default {
  components: {
    pagination,
  },

  props: {
    tagList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },

  data() {
    return {
      choiceListIds: [], //当前所选择的id
      allListIds: [],
      indeterminate: false, //全选
      pageParams: {
        page: 1,
        pageSize: 30,
        showState: "",
        contentKeyword: "",
      },
      items: [],
      statusList: [
        { text: "状态筛选", value: "" },
        { text: "上架", value: "1" },
        { text: "下架", value: "0" },
      ],
    };
  },

  watch: {
    choiceListIds: function() {
      if (
        this.choiceListIds.length == this.allListIds.length &&
        this.choiceListIds.length > 0
      ) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
  },

  mounted() {
    this.getList();
  },

  created() {},

  methods: {
    //获取列表数据
    getList() {
      let paramsUrl = {
        page: this.pageParams.page,
        pageSize: this.pageParams.pageSize,
        "q%5Bmerchant_id%5D": JSON.parse(localStorage.chosedMedia).id,
        "q%5Bstatus%5D": this.pageParams.showState,
        "q%5Bkeywords%5D": this.pageParams.contentKeyword,
      };
      let params = this.utils.getQuery(paramsUrl);
      this.$refs.loading.show();
      this.items = [];
      console.log(params);
      conpon.list(params).then((resp) => {
        if (resp.code == 0) {
          if (resp.data.items) {
            if (this.$refs.loading) {
  this.$refs.loading.hide(resp.data.items);
}
            let ids = [];
            resp.data.items.map((item) => {
              ids.push(item.id);
              if (item.createdAt) {
                item.createdAt = this.utils.getTimeStamp(item.createdAt);
              }
            });
            this.choiceListIds = [];
            this.allListIds = ids; //当前列表全部id
            this.items = resp.data.items;
            let pages = {
              page: resp.data.page, //第几页
              pageSize: resp.data.pageSize, //每页多少条
              total: resp.data.total, //全部有多少条数据
              totalPages: resp.data.totalPages, //全部有几页
            };
            this.$nextTick(() => {
  if (this.$refs.page) {
    this.$refs.page.setPages(pages);
  }
});
          }
        } else {
          if (this.$refs.loading) {
  this.$refs.loading.hide();
}
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getList();
      }
      if (obj.code === "batch") {
      } //处理批量操作
    },

    //添加
    toCreate() {
      this.$router.push({
        name: "couponDetail",
      });
    },

    toReceiveList(item) {
      this.$router.push({
        name: "couponsReceive",
        query: { id: item.id },
      });
    },

    toThirdParty(item) {
      this.$router.push({
        name: "thirdPartyCoupons",
        query: { id: item.id },
      });
    },

    //去编辑
    toDetail(item, allModify) {
      if (allModify) {
        this.$router.push({
          name: "couponDetail",
          query: { id: item.id, allModify: true },
        });
      } else {
        this.$router.push({
          name: "couponDetail",
          query: { id: item.id },
        });
      }
    },

    openReject(item) {
      Swal.fire({
        title: "驳回原因",
        text: item.taboo,
        confirmButtonColor: "#556ee6",
      });
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.showState = "";
      this.pageParams.contentKeyword = "";
      this.getList();
    },

    // 列表全选
    checkedAll() {
      if (this.indeterminate) {
        this.choiceListIds = this.allListIds;
      } else {
        this.choiceListIds = [];
      }
    },

    modifyStatus(item, status) {
      let title_text = status == 1 ? "确定上架？" : "确定下架？";
      Swal.fire({
        title: title_text,
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {
            id: item.id,
            status: status,
          };
          conpon.isStatus(params).then((resp) => {
            if (resp.code == 0) {
              let success_text = status == 1 ? "上架成功" : "下架成功";
              Vue.swal({
                icon: "success",
                title: success_text,
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    batchExamine(item) {
      Swal.fire({
        title: "确定提交审核?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "提交",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          conpon.examine(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "提交成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    batchRevert(item) {
      Swal.fire({
        title: "确定撤销审核?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          if (item) {
            params.ids = [];
            params.ids.push(item.id);
          } else {
            params.ids = this.choiceListIds;
          }
          conpon.revert(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "撤销成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal(resp.msg);
            }
          });
        }
      });
    },

    remove(item) {
      Swal.fire({
        title: "确定删除?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#74788d",
        confirmButtonText: "删除",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.value) {
          let params = {};
          params.id = item.id;
          // if(item){
          //   params.ids = []
          //   params.ids.push(item.id)
          // } else {
          //   params.ids = this.choiceListIds
          // }
          conpon.remove(params).then((resp) => {
            if (resp.code == 0) {
              Vue.swal({
                icon: "success",
                title: "删除成功！",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getList();
            } else {
              Vue.swal({
                icon: "error",
                title: resp.msg,
                showConfirmButton: false,
                timer: 1500,
              });
            }
          });
        }
      });
    },
  },
};
</script>
